import { makeStyles } from "@material-ui/core";

// Quill's video button saves a bare `<iframe class="ql-video">` with no size,
// so it renders at the browser default 300×150. YouTube's player crops its
// preview to fill that box, but Vimeo's letterboxes it, so Vimeo gets a 16:9
// box of the same width. Vimeo's player is transparent around a thumbnail of
// another ratio, so the black background keeps those bars inside the player.
export const VIMEO_VIDEO_EMBED_STYLES = {
  '& iframe.ql-video[src*="player.vimeo.com"]': {
    width: 300,
    maxWidth: "100%",
    height: "auto",
    aspectRatio: "16 / 9",
    backgroundColor: "#000",
  },
};

export default makeStyles(() => ({
  root: {
    "& p": {
      margin: 0,
    },
    "& a": {
      wordBreak: "break-all",
    },
    "& img": {
      maxWidth: "100%",
    },
    ...VIMEO_VIDEO_EMBED_STYLES,
  },
}));
